import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IRemoteRefreshSchedule } from '../types/IRemoteRefreshSchedule';
import { Request } from '../../../httpClient/serverApi/requests/Request';

// Remote refreshes can be full or incremental
export const RemoteRefreshTypes = {
  Full: 'Full',
  Incremental: 'Incremental'
};

export interface IRemoteRefreshSchedulesResult extends IGetItemsResult {
  schedules: IRemoteRefreshSchedule[];
  expectedRefreshDuration: number;
}

// Given a datasource id, get the remote refresh schedules
export class GetRemoteRefreshSchedulesRequest extends Request<IGetItemsParams, IRemoteRefreshSchedulesResult> {
  constructor(params: IGetItemsParams) {
    super('getRemoteRefreshSchedules', params);
  }
}
